import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { calcTotals, fmtEUR, fmtDate } from "./storage";

function buildBudgetPDFDoc(budget) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();
  const margin = 40;

  // Header
  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.setTextColor(37, 99, 235);
  doc.text("Reformas Express", margin, 60);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(100);
  doc.text("Presupuesto profesional de reforma", margin, 78);

  // Budget meta (right)
  doc.setTextColor(15, 23, 42);
  doc.setFont("helvetica", "bold");
  doc.text(`Presupuesto Nº: ${budget.id}`, pageW - margin, 60, { align: "right" });
  doc.setFont("helvetica", "normal");
  doc.text(`Fecha: ${fmtDate(budget.fecha)}`, pageW - margin, 76, { align: "right" });
  doc.text(`Tipo: ${budget.tipo === "rapido" ? "Rápido" : "Completo"}`, pageW - margin, 92, { align: "right" });

  // Client block
  let y = 130;
  doc.setDrawColor(226, 232, 240);
  doc.line(margin, y - 20, pageW - margin, y - 20);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("CLIENTE", margin, y);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  const c = budget.cliente || {};
  const lines = [
    c.nombre || "—",
    c.nif ? `NIF/CIF: ${c.nif}` : null,
    c.direccion || null,
    c.telefono ? `Tel: ${c.telefono}` : null,
    c.email || null,
  ].filter(Boolean);
  lines.forEach((ln, i) => doc.text(ln, margin, y + 18 + i * 14));

  // Partidas table
  const startY = y + 18 + lines.length * 14 + 18;
  const rows = (budget.partidas || []).map((p, i) => {
    const concepto =
      (p.concepto ?? p.descripcion ?? "") +
      (p.is_estimation ? "  (Est. IA)" : "");
    const cantidad = Number(p.cantidad) || 0;
    const precio = Number(p.precio_unitario) || 0;
    return [
      i + 1,
      concepto,
      p.unidad ?? "ud",
      cantidad.toLocaleString("es-ES"),
      fmtEUR(precio),
      fmtEUR(cantidad * precio),
    ];
  });

  autoTable(doc, {
    startY,
    head: [["#", "Descripción", "Ud", "Cant.", "P. Unit.", "Subtotal"]],
    body: rows,
    headStyles: {
      fillColor: [37, 99, 235],
      textColor: 255,
      fontStyle: "bold",
      fontSize: 10,
    },
    bodyStyles: { fontSize: 9, textColor: [15, 23, 42] },
    alternateRowStyles: { fillColor: [248, 250, 252] },
    columnStyles: {
      0: { cellWidth: 24, halign: "right" },
      1: { cellWidth: "auto" },
      2: { cellWidth: 30, halign: "center" },
      3: { cellWidth: 50, halign: "right" },
      4: { cellWidth: 70, halign: "right" },
      5: { cellWidth: 80, halign: "right" },
    },
    margin: { left: margin, right: margin },
  });

  const totals = calcTotals(budget.partidas);
  const totalsBlockW = 220;
  const labelX = pageW - margin - totalsBlockW;
  const valueX = pageW - margin;
  let endY = doc.lastAutoTable.finalY + 24;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(15, 23, 42);
  doc.text("Base imponible", labelX, endY);
  doc.text(fmtEUR(totals.base), valueX, endY, { align: "right" });

  endY += 18;
  doc.text("IVA (21%)", labelX, endY);
  doc.text(fmtEUR(totals.iva), valueX, endY, { align: "right" });

  endY += 10;
  doc.setDrawColor(37, 99, 235);
  doc.setLineWidth(1);
  doc.line(labelX, endY, valueX, endY);

  endY += 22;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.setTextColor(37, 99, 235);
  doc.text("TOTAL", labelX, endY);
  doc.text(fmtEUR(totals.total), valueX, endY, { align: "right" });

  // Footer
  doc.setFont("helvetica", "italic");
  doc.setFontSize(8);
  doc.setTextColor(100);
  doc.text(
    "Presupuesto generado con asistente IA. Revise siempre las partidas, cantidades y precios antes de confirmar.",
    margin,
    doc.internal.pageSize.getHeight() - 30
  );

  return doc;
}

export function exportBudgetPDF(budget) {
  const doc = buildBudgetPDFDoc(budget);
  doc.save(`Presupuesto_${budget.id}.pdf`);
}

export function getBudgetPDFBase64(budget) {
  const doc = buildBudgetPDFDoc(budget);
  const dataUri = doc.output("datauristring");
  const idx = dataUri.indexOf("base64,");
  return idx >= 0 ? dataUri.slice(idx + "base64,".length) : dataUri;
}
